export default __webpack_public_path__ + "static/media/Aelfrith's Grace.525fd7e3.jpg";